<div id="pbi-container" class="container-power-bi" [class.scrollbar]="show_scrollbar"></div>

